import classNames from 'classnames';
import React, { useState } from 'react';
import styles from './CardIcon.module.css';

export const CardIconNames = [
  '945',
  '116',
  '061',
  '037',
  '542',
  '014',
  '536',
  '133',
  '535',
  '567',
  '110',
  '425',
  '009',
  '145',
  '129',
  '137',
  '112',
  '555',
  '125',
  '124',
  '132',
  '688',
  '002',
  '494',
  '200',
  '547',
  '441',
  '521',
  '076',
  '054',
  '022',
  '031',
  '559',
  '950',
  '949',
  '011',
  '046',
  '526',
  '111',
  '161',
  '484',
  '087',
  '164',
  '513',
  '115',
  '472',
  '113',
  '114',
  '213',
  '123',
  '121',
  '131',
  '008',
  '451',
  '157',
  '097',
  '016',
  '553',
  '426',
  '151',
  '485',
  '147',
  '042',
  '118',
  '503',
  '128',
  '130',
  '028',
  '019',
  '013',
  '520',
  '167',
  '089',
  '119',
  '523',
  '498',
  '153',
  '050',
  '126',
  '134',
  '135',
  '127',
  '120',
  '117',
  '023',
  '566',
  '415',
  '036',
  'shopeepay',
  'shopeepay_ewallet',
  'dsp',
  'ovo',
  'ovo_ewallet',
  'gopay',
  'gopay_ewallet',
  'dana',
  'dana_ewallet',
  'linkaja',
  'linkaja_ewallet',
  'visa_master_card',
  'visa_master_card_jcb',
  'qris',
  'indomaret',
  'alfamart',
  'visa',
  'jcb',
  'master_card',
  'american_express',
] as const;

export type CardIconName = (typeof CardIconNames)[number];

const BASE_URL =
  'https://s3-ap-southeast-1.amazonaws.com/oy-static-assets/pay/uiicon/card';

const DEFAULT_BANK_URL = 'https://s3-ap-southeast-1.amazonaws.com/oy-static-assets/pay/uiicon/card/small/default_bank.svg';
const DEFAULT_EWALLET_URL = 'https://s3-ap-southeast-1.amazonaws.com/oy-static-assets/pay/uiicon/card/small/default_ewallet.svg';

const EWALLET_LIST = [
  "ovo",
  "gopay",
  "shopeepay",
  "linkaja",
  "dana"
]

type CardIconProps = {
  size?: 'small' | 'medium' | 'large';
  /**
   * To add new icon, you need to ask infra team to upload your new icon.
   * And don't forget to add the name to {@link CardIconName}
   * @BASE_URL https://s3-ap-southeast-1.amazonaws.com/oy-static-assets/pay/uiicon/card
   */
  name: CardIconName;
  disabled?: boolean;
};

function CardIcon({ size = 'small', name, disabled = false }: CardIconProps) {
  const [imageError, setImageError] = useState(false);
  let src: string;
  if (size === 'medium') {
    src = `${BASE_URL}/small/${name}.svg`;
  } else {
    src = `${BASE_URL}/${size}/${name}.svg`;
  }
  return (
    <div>
      {
        imageError ? <img
          alt="icon"
          src={EWALLET_LIST.includes(name) ? DEFAULT_EWALLET_URL : DEFAULT_BANK_URL}
          className={classNames(styles[size], {
            [styles.grayscale]: disabled,
          })}
        /> : <img
          alt="icon"
          src={src}
          className={classNames(styles[size], {
            [styles.grayscale]: disabled,
          })}
          onError={() => setImageError(true)}
        />
      }
    </div>
  );
}

export default CardIcon;
